import { shape, number } from 'prop-types';

export const userType = shape({
  user_id: number,
});
